const flipcard = () => {

	[].forEach.call(document.querySelectorAll('.c-flipcard'), function(el) {
		el.addEventListener('click', function() {
			el.classList.toggle("c-flipcard--toggled");
		})
	});
	
};

export default flipcard;